<template>
  <div class="app-container">
    <wd-navbar class="tarbar">
      <div slot="left" class="middle" @click="$goHome">
        <wd-icon name="arrow-left" />
      </div>
      <div style="white-space: nowrap">
        <span style="white-space: nowrap">{{
          equipInfo.equipmentName || '--'
        }}</span>
      </div>
    </wd-navbar>
    <div>
      <div>
        <!--        <span style="margin-left: 15px; font-size: 14px; padding: 10px 0; display: block; color: #fa4350">查询对象：{{equipInfo.equipmentName || '&#45;&#45;'}}</span>-->
        <!-- <wd-datetime-picker
          ref="startDatePickerRef"
          class="group-picker-cell-icon atomic-no-top-border"
          type="date"
          v-model="searchObject.startDate"
          :default-value="searchObject.startDate"
          @click.native="fixFlagOpen"
        >
          <template #label>
            <span>开始时间</span>
            <img
              style="width: 1.5em; height: 1.5em"
              src="~@/assets/img/icon-calendar.png"
              alt=""
            />
          </template>
        </wd-datetime-picker>
        <wd-datetime-picker
          ref="endDatePickerRef"
          class="group-picker-cell-icon atomic-no-top-border"
          type="date"
          v-model="searchObject.endDate"
          :default-value="searchObject.endDate"
          @click.native="fixFlagOpen"
        >
          <template #label>
            <span>结束时间</span>
            <img
              style="width: 1.5em; height: 1.5em"
              src="~@/assets/img/icon-calendar.png"
              alt=""
            />
          </template>
        </wd-datetime-picker> -->
        <van-cell
          title="开始时间"
          :value="$moment(searchObject.startDate).format('YYYY-MM-DD')"
          @click="() => dataTimeClick('start', true)"
        />
        <van-popup
          v-model="datePickerObj.startDateShow"
          round
          position="bottom"
          :style="{ height: '50%' }"
          :close-on-click-overlay="false"
        >
          <van-datetime-picker
            v-model="searchObject.startDate"
            type="date"
            title="选择年月日"
            @cancel="() => dataTimeClick('start', false)"
            @confirm="() => dataTimeClick('start', false)"
          />
        </van-popup>
        <van-cell
          title="结束时间"
          :value="$moment(searchObject.endDate).format('YYYY-MM-DD')"
          @click="() => dataTimeClick('end', true)"
        />
        <van-popup
          v-model="datePickerObj.endDateShow"
          round
          position="bottom"
          :style="{ height: '50%' }"
          :close-on-click-overlay="false"
        >
          <van-datetime-picker
            v-model="searchObject.endDate"
            type="date"
            title="选择年月日"
            @cancel="() => dataTimeClick('end', false)"
            @confirm="() => dataTimeClick('end', false)"
          />
        </van-popup>
      </div>

      <div class="usage-box">
        <img class="usage-icon" src="~@/assets/img/usage-electr.png" alt="" />
        <p class="usage-text">
          <font>用量合计：</font>
          <font style="font-size: 18px; color: #fa4350"
            >{{ dataInfo.totalUsage || '0'
            }}<font v-if="equipInfo.equipmentType == '0'">度</font
            ><font v-else>吨</font></font
          >
        </p>
        <wd-button class="usage-button" @click="getList">
          <img src="~@/assets/img/search.svg" />
          搜 索
        </wd-button>
      </div>
    </div>
    <wd-cell-group style="margin-top: 20px">
      <wd-cell title="昨日用量" class="group-list-cell">
        <font style="font-size: 16px; color: #1f6ecf"
          >{{ dataInfo.lastDayUsage || '0'
          }}<font v-if="equipInfo.equipmentType == '0'">度</font
          ><font v-else>吨</font></font
        >
      </wd-cell>
      <wd-cell title="前日用量" class="group-list-cell atomic-no-top-border">
        <font style="font-size: 16px; color: #1f6ecf"
          >{{ dataInfo.lastTwoDayUsage || '0'
          }}<font v-if="equipInfo.equipmentType == '0'">度</font
          ><font v-else>吨</font></font
        >
      </wd-cell>
    </wd-cell-group>
  </div>
</template>

<script>
// 修复Wot Design日期选择器首次切换月份，日跳转为01日实际未改变bug
// import fixWdDatePicker from "@/mixin/fixWdDatePicker";
import { Toast } from 'vant'

export default {
  // mixins: [fixWdDatePicker],
  data() {
    return {
      searchObject: {
        startDate: null,
        endDate: null,
      },
      // fixStartDate: "",
      // fixEndDate: "",
      equipInfo: {},
      dataInfo: {},

      datePickerObj: {
        startDateShow: false,
        endDateShow: false,
      },
    }
  },
  created() {
    // this.$set(
    //   this.searchObject,
    //   "startDate",
    //   new Date(this.$moment().subtract(3, "days").format("YYYY-MM-DD"))
    // );
    // this.$set(
    //   this.searchObject,
    //   "endDate",
    //   new Date(this.$moment().format("YYYY-MM-DD"))
    // );
    this.searchObject.startDate = new Date(
      this.$moment()
        .subtract(3, 'days')
        .format('YYYY-MM-DD')
    )
    this.searchObject.endDate = new Date(this.$moment().format('YYYY-MM-DD'))
    this.equipInfo = this.$route.params
    console.log(this.equipInfo)
    if (!this.equipInfo.id) {
      this.$router.push('/selectEquip')
    } else {
      if (!this.equipInfo.equipmentName) {
        this.equipInfo.equipmentName = this.equipInfo.acctName
      }
      if (!this.equipInfo.equipmentType) {
        this.equipInfo.equipmentType = this.equipInfo.acctType
      }
      this.getList()
    }
  },
  // mounted() {
  //   // 修复Wot Design日期选择器首次切换月份日跳转为1日实际为改变bug
  //   this.fixPickerWatch(this, "startDatePickerRef", "fixStartDate");
  //   this.fixPickerWatch(this, "endDatePickerRef", "fixEndDate");
  // },
  methods: {
    getList() {
      // let startDate =
      //   this.$moment(
      //     this.fixPickerValue(this, this.searchObject.startDate, "fixStartDate")
      //   ).format("YYYY-MM-DD") + " 00:00:00";
      // let endDate =
      //   this.$moment(
      //     this.fixPickerValue(this, this.searchObject.endDate, "fixEndDate")
      //   ).format("YYYY-MM-DD") + " 23:59:59";

      let startDate = `${this.$moment(this.searchObject.startDate).format(
        'YYYY-MM-DD'
      )} 00:00:00`
      let endDate = `${this.$moment(this.searchObject.endDate).format(
        'YYYY-MM-DD'
      )} 23:59:59`
      let params = {
        id: this.equipInfo.id,
        startDate: startDate,
        endDate: endDate,
      }
      this.$http.post('/external/bill', params).then((res) => {
        if (res.code == 200) {
          this.$set(this.dataInfo, 'totalUsage', res.totalUsage)
          this.$set(this.dataInfo, 'lastTwoDayUsage', res.lastTwoDayUsage)
          this.$set(this.dataInfo, 'lastDayUsage', res.lastDayUsage)
        }
      })
    },
    dataTimeClick(type, show) {
      let handleObj = {
        start: {
          showType: 'startDateShow',
        },
        end: {
          showType: 'endDateShow',
        },
      }
      const { showType } = handleObj[type]
      if (show == true) return (this.datePickerObj[showType] = show)

      const startDateTime = new Date(this.searchObject.startDate).getTime()
      const endDateTime = new Date(this.searchObject.endDate).getTime()

      if (startDateTime > endDateTime) {
        Toast({
          message: '开始时间不能大于结束时间',
          position: 'top',
        })
        return
      }

      this.datePickerObj[showType] = show
    },
  },
}
</script>

<style lang="less" scoped>
.button {
  /deep/ .wd-button__txt {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.tarbar {
  /deep/ .wd-navbar__title {
    flex: 5;
    white-space: nowrap;
    overflow: visible;
  }
}

.usage-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  .usage-icon {
    width: 100px;
    height: 100px;
  }
  .usage-text {
    font-size: 14px;
  }
  .usage-button {
    width: 100px;
    img {
      width: 1.5em;
      height: 1.5em;
      vertical-align: -6px;
      margin-right: 3px;
    }
  }
}
</style>
